import React, { useState } from 'react';
import { UserIcon, CalendarIcon, BellIcon, LinkIcon, BarChartIcon, MessageSquareIcon, StarIcon, ShieldIcon, ChevronRightIcon, XIcon, LogOutIcon, InfoIcon, CheckIcon, ClipboardCheckIcon } from 'lucide-react';
export function SettingsScreen({
  eventCount = 0,
  onSignOut = () => {},
  onEditProfile = () => {}
}) {
  const [isCalendarConnected, setIsCalendarConnected] = useState(true);
  const [showDisconnectModal, setShowDisconnectModal] = useState(false);
  // Notification settings state
  const [eventRemindersEnabled, setEventRemindersEnabled] = useState(true);
  const [registrationDeadlinesEnabled, setRegistrationDeadlinesEnabled] = useState(true);
  const [systemNotificationsEnabled, setSystemNotificationsEnabled] = useState(true);
  // Reminder timing options
  const [goingReminders, setGoingReminders] = useState({
    oneWeek: false,
    oneDay: true,
    threeHours: true
  });
  const [interestedReminders, setInterestedReminders] = useState({
    oneDay: true
  });
  const handleDisconnectCalendar = () => {
    setIsCalendarConnected(false);
    setShowDisconnectModal(false);
  };
  const handleGoingReminderChange = timing => {
    setGoingReminders(prev => ({
      ...prev,
      [timing]: !prev[timing]
    }));
  };
  const handleInterestedReminderChange = timing => {
    setInterestedReminders(prev => ({
      ...prev,
      [timing]: !prev[timing]
    }));
  };
  const handleSignOut = () => {
    // In a real app, this would handle authentication logout
    onSignOut();
  };
  return <div className="space-y-6" data-id="element-462">
      {/* Profile Section */}
      <div className="bg-white rounded-lg shadow p-6" data-id="element-463">
        <div className="flex items-center" data-id="element-464">
          <div className="bg-blue-100 rounded-full p-3" data-id="element-465">
            <UserIcon className="w-8 h-8 text-blue-600" data-id="element-466" />
          </div>
          <div className="ml-4" data-id="element-467">
            <h2 className="text-lg font-medium" data-id="element-468">My Profile</h2>
            <p className="text-sm text-gray-500" data-id="element-469">{eventCount} events saved</p>
          </div>
          <button onClick={onEditProfile} className="ml-auto text-blue-600 text-sm hover:underline" data-id="element-470">
            Edit Profile
          </button>
        </div>
      </div>
      {/* Calendar & Export Section */}
      <div className="bg-white rounded-lg shadow overflow-hidden" data-id="element-471">
        <div className="px-4 py-3 bg-gray-50 border-b border-gray-200" data-id="element-472">
          <h3 className="text-sm font-medium text-gray-700" data-id="element-473">
            Calendar & Export
          </h3>
        </div>
        <div className="divide-y divide-gray-200" data-id="element-474">
          <div className="px-4 py-3" data-id="element-475">
            <div className="flex items-center justify-between" data-id="element-476">
              <div className="flex items-center" data-id="element-477">
                <CalendarIcon className="w-5 h-5 text-gray-400 mr-3" data-id="element-478" />
                <span className="text-sm" data-id="element-479">
                  {isCalendarConnected ? 'Event Calendar' : 'Connect Calendar'}
                </span>
              </div>
              {isCalendarConnected ? <button onClick={() => setShowDisconnectModal(true)} className="text-sm text-red-600 hover:text-red-700 flex items-center" data-id="element-480">
                  <LogOutIcon className="w-4 h-4 mr-1" data-id="element-481" />
                  Disconnect
                </button> : <div className="flex items-center text-sm text-gray-500" data-id="element-482">
                  <span data-id="element-483">Export events to your calendar</span>
                  <ChevronRightIcon className="w-4 h-4 ml-1" data-id="element-484" />
                </div>}
            </div>
            {isCalendarConnected && <div className="mt-2 pl-8" data-id="element-485">
                <div className="text-sm" data-id="element-486">
                  Connected: Google Calendar (Personal)
                </div>
                <div className="text-xs text-gray-500" data-id="element-487">john.doe@gmail.com</div>
              </div>}
          </div>
          <div className="flex items-center justify-between px-4 py-3" data-id="element-488">
            <div className="flex items-center" data-id="element-489">
              <LinkIcon className="w-5 h-5 text-gray-400 mr-3" data-id="element-490" />
              <div data-id="element-491">
                <span className="text-sm" data-id="element-492">Include Source Links</span>
                <p className="text-xs text-gray-500" data-id="element-493">
                  Add original links to calendar events
                </p>
              </div>
            </div>
            <label className="relative inline-flex items-center cursor-pointer" data-id="element-494">
              <input type="checkbox" value="" className="sr-only peer" defaultChecked data-id="element-495" />
              <div className="w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-blue-600" data-id="element-496"></div>
            </label>
          </div>
        </div>
      </div>
      {/* Notifications Section - Separate section as requested */}
      <div className="bg-white rounded-lg shadow overflow-hidden" data-id="element-497">
        <div className="px-4 py-3 bg-gray-50 border-b border-gray-200" data-id="element-498">
          <h3 className="text-sm font-medium text-gray-700" data-id="element-499">Notifications</h3>
        </div>
        <div className="divide-y divide-gray-200" data-id="element-500">
          {/* Event Reminders */}
          <div className="px-4 py-4" data-id="element-501">
            <div className="flex items-center justify-between mb-2" data-id="element-502">
              <div className="flex items-center" data-id="element-503">
                <BellIcon className="w-5 h-5 text-gray-400 mr-3" data-id="element-504" />
                <span className="text-sm font-medium" data-id="element-505">Event Reminders</span>
              </div>
              <label className="relative inline-flex items-center cursor-pointer" data-id="element-506">
                <input type="checkbox" className="sr-only peer" checked={eventRemindersEnabled} onChange={() => setEventRemindersEnabled(!eventRemindersEnabled)} data-id="element-507" />
                <div className="w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-blue-600" data-id="element-508"></div>
              </label>
            </div>
            <p className="text-xs text-gray-500 ml-8 mb-3" data-id="element-509">
              Get notified before events you're attending
            </p>
            {eventRemindersEnabled && <div className="ml-8 space-y-4" data-id="element-510">
                <div className="space-y-2" data-id="element-511">
                  <p className="text-sm font-medium text-gray-700 mb-1" data-id="element-512">
                    When you mark an event as "Going":
                  </p>
                  <div className="flex items-center space-x-2" data-id="element-513">
                    <input type="checkbox" id="oneWeekBefore" checked={goingReminders.oneWeek} onChange={() => handleGoingReminderChange('oneWeek')} className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500" data-id="element-514" />
                    <label htmlFor="oneWeekBefore" className="text-sm text-gray-700" data-id="element-515">
                      1 week before
                    </label>
                  </div>
                  <div className="flex items-center space-x-2" data-id="element-516">
                    <input type="checkbox" id="oneDayBefore" checked={goingReminders.oneDay} onChange={() => handleGoingReminderChange('oneDay')} className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500" data-id="element-517" />
                    <label htmlFor="oneDayBefore" className="text-sm text-gray-700" data-id="element-518">
                      1 day before
                    </label>
                  </div>
                  <div className="flex items-center space-x-2" data-id="element-519">
                    <input type="checkbox" id="threeHoursBefore" checked={goingReminders.threeHours} onChange={() => handleGoingReminderChange('threeHours')} className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500" data-id="element-520" />
                    <label htmlFor="threeHoursBefore" className="text-sm text-gray-700" data-id="element-521">
                      3 hours before
                    </label>
                  </div>
                </div>
                <div className="space-y-2" data-id="element-522">
                  <p className="text-sm font-medium text-gray-700 mb-1" data-id="element-523">
                    When you mark an event as "Interested":
                  </p>
                  <div className="flex items-center space-x-2" data-id="element-524">
                    <input type="checkbox" id="interestedOneDayBefore" checked={interestedReminders.oneDay} onChange={() => handleInterestedReminderChange('oneDay')} className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500" data-id="element-525" />
                    <label htmlFor="interestedOneDayBefore" className="text-sm text-gray-700" data-id="element-526">
                      1 day before
                    </label>
                  </div>
                </div>
              </div>}
          </div>
          {/* Registration Deadlines */}
          <div className="px-4 py-4" data-id="element-527">
            <div className="flex items-center justify-between mb-2" data-id="element-528">
              <div className="flex items-center" data-id="element-529">
                <ClipboardCheckIcon className="w-5 h-5 text-gray-400 mr-3" data-id="element-530" />
                <span className="text-sm font-medium" data-id="element-531">
                  Registration Deadlines
                </span>
              </div>
              <label className="relative inline-flex items-center cursor-pointer" data-id="element-532">
                <input type="checkbox" className="sr-only peer" checked={registrationDeadlinesEnabled} onChange={() => setRegistrationDeadlinesEnabled(!registrationDeadlinesEnabled)} data-id="element-533" />
                <div className="w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-blue-600" data-id="element-534"></div>
              </label>
            </div>
            <div className="ml-8 space-y-1" data-id="element-535">
              <p className="text-xs text-gray-500" data-id="element-536">
                Alerts when registration closes soon (3 days or less)
              </p>
              <p className="text-xs text-gray-500" data-id="element-537">
                For events marked "Going" or "Interested"
              </p>
            </div>
          </div>
          {/* System Notifications */}
          <div className="px-4 py-4" data-id="element-538">
            <div className="flex items-center justify-between mb-2" data-id="element-539">
              <div className="flex items-center" data-id="element-540">
                <MessageSquareIcon className="w-5 h-5 text-gray-400 mr-3" data-id="element-541" />
                <span className="text-sm font-medium" data-id="element-542">
                  System Notifications
                </span>
              </div>
              <label className="relative inline-flex items-center cursor-pointer" data-id="element-543">
                <input type="checkbox" className="sr-only peer" checked={systemNotificationsEnabled} onChange={() => setSystemNotificationsEnabled(!systemNotificationsEnabled)} data-id="element-544" />
                <div className="w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-blue-600" data-id="element-545"></div>
              </label>
            </div>
            <p className="text-xs text-gray-500 ml-8" data-id="element-546">
              App updates and important announcements
            </p>
          </div>
        </div>
      </div>
      {/* Data & Privacy Section */}
      <div className="bg-white rounded-lg shadow overflow-hidden" data-id="element-547">
        <div className="px-4 py-3 bg-gray-50 border-b border-gray-200" data-id="element-548">
          <h3 className="text-sm font-medium text-gray-700" data-id="element-549">Data & Privacy</h3>
        </div>
        <div className="divide-y divide-gray-200" data-id="element-550">
          <div className="flex items-center justify-between px-4 py-3" data-id="element-551">
            <div className="flex items-center" data-id="element-552">
              <BarChartIcon className="w-5 h-5 text-gray-400 mr-3" data-id="element-553" />
              <div data-id="element-554">
                <span className="text-sm" data-id="element-555">Analytics</span>
                <p className="text-xs text-gray-500" data-id="element-556">Help us improve the app</p>
              </div>
            </div>
            <label className="relative inline-flex items-center cursor-pointer" data-id="element-557">
              <input type="checkbox" value="" className="sr-only peer" defaultChecked data-id="element-558" />
              <div className="w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-blue-600" data-id="element-559"></div>
            </label>
          </div>
        </div>
      </div>
      {/* Support & Info Section */}
      <div className="bg-white rounded-lg shadow overflow-hidden" data-id="element-560">
        <div className="px-4 py-3 bg-gray-50 border-b border-gray-200" data-id="element-561">
          <h3 className="text-sm font-medium text-gray-700" data-id="element-562">Support & Info</h3>
        </div>
        <div className="divide-y divide-gray-200" data-id="element-563">
          <div className="flex items-center justify-between px-4 py-3" data-id="element-564">
            <div className="flex items-center" data-id="element-565">
              <MessageSquareIcon className="w-5 h-5 text-gray-400 mr-3" data-id="element-566" />
              <span className="text-sm" data-id="element-567">Send Feedback</span>
            </div>
            <ChevronRightIcon className="w-4 h-4 text-gray-400" data-id="element-568" />
          </div>
          <div className="flex items-center justify-between px-4 py-3" data-id="element-569">
            <div className="flex items-center" data-id="element-570">
              <StarIcon className="w-5 h-5 text-gray-400 mr-3" data-id="element-571" />
              <span className="text-sm" data-id="element-572">Rate the App</span>
            </div>
            <ChevronRightIcon className="w-4 h-4 text-gray-400" data-id="element-573" />
          </div>
          <div className="flex items-center justify-between px-4 py-3" data-id="element-574">
            <div className="flex items-center" data-id="element-575">
              <ShieldIcon className="w-5 h-5 text-gray-400 mr-3" data-id="element-576" />
              <span className="text-sm" data-id="element-577">Privacy Policy</span>
            </div>
            <ChevronRightIcon className="w-4 h-4 text-gray-400" data-id="element-578" />
          </div>
        </div>
      </div>
      {/* Sign Out Section - Now separate as requested */}
      <div className="bg-white rounded-lg shadow overflow-hidden" data-id="element-579">
        <div className="flex items-center justify-between px-4 py-3" data-id="element-580">
          <div className="flex items-center" data-id="element-581">
            <LogOutIcon className="w-5 h-5 text-gray-400 mr-3" data-id="element-582" />
            <span className="text-sm" data-id="element-583">Sign Out</span>
          </div>
          <button onClick={handleSignOut} className="text-gray-500 hover:text-gray-700" data-id="element-584">
            <ChevronRightIcon className="w-4 h-4" data-id="element-585" />
          </button>
        </div>
      </div>
      <div className="text-center text-xs text-gray-400 py-4" data-id="element-586">
        Version 1.0.0
      </div>
      {/* Disconnect Calendar Modal */}
      {showDisconnectModal && <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" data-id="element-587">
          <div className="bg-white rounded-lg max-w-md w-full p-6 shadow-xl" data-id="element-588">
            <div className="flex items-center justify-between mb-4" data-id="element-589">
              <h3 className="text-lg font-medium" data-id="element-590">Disconnect Calendar</h3>
              <button onClick={() => setShowDisconnectModal(false)} className="text-gray-400 hover:text-gray-500" data-id="element-591">
                <XIcon className="w-5 h-5" data-id="element-592" />
              </button>
            </div>
            <div className="mb-6" data-id="element-593">
              <p className="text-gray-600 mb-2" data-id="element-594">
                Are you sure you want to disconnect your Google Calendar?
              </p>
              <p className="text-sm text-gray-500" data-id="element-595">
                Your events will no longer sync with your calendar, but you can
                reconnect at any time.
              </p>
            </div>
            <div className="flex justify-end space-x-3" data-id="element-596">
              <button onClick={() => setShowDisconnectModal(false)} className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-597">
                Cancel
              </button>
              <button onClick={handleDisconnectCalendar} className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-red-600 hover:bg-red-700" data-id="element-598">
                Disconnect
              </button>
            </div>
          </div>
        </div>}
    </div>;
}